import {connect} from 'react-redux';

import {makeMapDispatchToProps} from '../../../../srcCommon/helpers/reselectHelpers';
import {AccountModel} from '../../../models/api/accountModel';
import {domainsRemovedAction} from '../../../store/panels/accounts/accountDetailsPanelActions';
import {ContactOrAccountDetailsPanelId} from '../../../store/panels/panelStateBase';
import {RemoveEmailDomainsDialog} from './removeEmailDomainsDialog';

/*
 * Props.
 */

interface RemoveEmailDomainsDialogContainerProps {
  panelId: ContactOrAccountDetailsPanelId;
  account: AccountModel;
}

/*
 * Redux.
 */

const mapDispatchToProps = makeMapDispatchToProps<RemoveEmailDomainsDialogContainerProps>()((props) => ({
  onRemoveDomains: () => domainsRemovedAction(props.panelId, props.account),
}));

export const RemoveEmailDomainsContainerDialog = connect(null, mapDispatchToProps)(RemoveEmailDomainsDialog);
